// extracted by mini-css-extract-plugin
export var drawerPaper = "_2d-0";
export var itemCard = "_2d-1";
export var itemImage = "_2d-2";